import { Modal } from "antd";
import { ReactComponent as CloseSvg } from './icons/close.svg';
import classNames from "classnames";
import './index.less';

interface Iprop {
    children?: any,
    // 样式名
    wrapClassName?: string
    // 弹窗标题
    title: string,
    // 弹窗显隐
    visible: boolean,
    setVisible: (e) => void,
    // 保存按钮名称
    saveName?: string,
    onSaveClick: () => void
    // 取消按钮名称
    cancelName?: string,
    // 取消按钮按下事件,可空
    onCancelClick?: () => void,

    // 保存按钮是否不可用
    saveDisable?: boolean
    // 取消按钮是否不可用
    cancelDisable?: boolean
}


export default function ConfirmModal(props: Iprop) {

    const onSaveClick = () => {
        if (props?.saveDisable) {
            return
        }
        props.onSaveClick();
        // props.setVisible(false)
    }

    const onCancelClick = () => {
        if (props?.cancelDisable) {
            return
        }
        if (props?.onCancelClick) {
            props?.onCancelClick();
        }
        props.setVisible(false)
    }

    return (
        <Modal
            open={props.visible}
            onCancel={() => { props.setVisible(false) }}
            footer={null}
            closable={false}
            wrapClassName={`tn-base-modal${props?.wrapClassName ? (" " + props?.wrapClassName) : ""}`}
            mask
            destroyOnClose
        >
            <div className='body'>
                <div className='title'>
                    <div className='name'>
                        {props.title}
                    </div>
                    <div className='icon' onClick={() => { props.setVisible(false) }}>
                        <CloseSvg />
                    </div>
                </div>
                <div className='main'>
                    {props.children}
                </div>
                <div className='button-area'>
                    <div className={classNames({
                        "cancel": true,
                        "cancel-disable": props.cancelDisable
                    })}
                        onClick={() => { onCancelClick() }}
                    >
                        {props?.cancelName || "取消"}
                    </div>
                    <div className={classNames({
                        "save": true,
                        "save-disable": props.saveDisable
                    })}
                        onClick={() => { onSaveClick() }}
                    >
                        {props?.saveName || "确认"}
                    </div>
                </div>
            </div>
        </Modal>
    )
}